module.exports = "/_next/static/images/no-result-bi-df9a6e6aac598ca6d0e131cbe47b19e0.svg";